import { useInfiniteQuery } from "@tanstack/react-query";
import { ApiGetCustodyExitRecords } from "@/api";
import type {
  GetCustodyExitRecordsRequest,
  GetCustodyExitRecordsResponse,
} from "@/api/types";
import { getToken } from "@/lib/auth";

const PAGE_SIZE = 100;

export function useGetCustodyExitRecords(mergedOrderId?: string) {
  return useInfiniteQuery({
    queryKey: ["custodyExitRecords", mergedOrderId ?? ""],
    queryFn: async ({ pageParam }): Promise<GetCustodyExitRecordsResponse> => {
      const req: GetCustodyExitRecordsRequest = {
        page: pageParam,
        pageSize: PAGE_SIZE,
      };
      if (mergedOrderId) req.mergedOrderId = mergedOrderId;
      const res = await ApiGetCustodyExitRecords(req);
      return res.data;
    },
    initialPageParam: 1,
    getNextPageParam: (lastPage, allPages) => {
      const fetched = allPages.reduce(
        (sum, page) => sum + (page.records?.length ?? 0),
        0
      );
      if (fetched >= (lastPage.total ?? 0)) return undefined;
      return allPages.length + 1;
    },
    enabled: !!getToken(),
  });
}
